import { sortByValueUsd } from "rujira.ui";
import type { UnifiedPrivateRow } from "../../../common/components/Balance";
import { showsPrivateBalance } from "../privateRows";
import type { PrivacyAsset } from "./privacyDisplay";

/**
 * The private assets "Learn more" explains, most valuable first, from the
 * rows the table already has. "Hide low value balances" is ignored on
 * purpose: a view filter must not hide a traced asset from the explanation.
 */
export const privacyAssetsOf = (
  rows: readonly UnifiedPrivateRow[]
): PrivacyAsset[] =>
  sortByValueUsd(rows.filter((row) => showsPrivateBalance(row, false))).flatMap(
    (row) => {
      const denom = row.asset.variants?.native?.denom;
      return denom ? [{ denom, symbol: row.asset.metadata.symbol }] : [];
    }
  );
